module.exports = __webpack_public_path__ + "static/media/twitter.ed2f9b31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/twitter.svg
// module id = 218
// module chunks = 0